import { FieldSelectOptions, OptionDefinition, OptionsetFieldDefinition } from '@msdk/definitions'
import { OptionItem } from '@msdk/ui'

export function filterOptions(
  fieldDef: OptionsetFieldDefinition,
  opts: OptionDefinition[],
  selectOptions: FieldSelectOptions,
  t: (idml: string, description: string) => string,
): OptionItem[] {
  if (!selectOptions) selectOptions = { keep: opts.map((opt) => opt.value), remove: [] }
  if (selectOptions.keep.length === 0) selectOptions.keep = opts.map((opt) => opt.value)

  const items = opts
    .filter((o) => selectOptions.keep.indexOf(o.value) !== -1)
    .filter((o) => selectOptions.remove.indexOf(o.value) === -1)
    .map((opt) => {
      return {
        value: opt.value,
        label: t(opt.idml, opt.description),
        color: opt.fontColor,
        icon: opt.icon,
      }
    })

  if (fieldDef.ignoreAlphabeticalOrder) return items
  else return items.sort((a, b) => a.label.localeCompare(b.label))
}
